import {mapGetters} from "vuex"
import btnClose from '@/components/btnClose/btnClose.vue'
export default {
    name: "successModal",
    components:{
        btnClose
    },
    methods: {
        // redirect() {
        //     this.$router.push('/my-gates')
        // },
        changeVision() {
            this.$store.dispatch('changeVisionSuccess')
        },
    },
    computed: mapGetters(['toogleSuccess'])
}